/**
 * Autogenerated file don't modify
 */
(function () {
(function () {
    'use strict';

    var highchartEls = document.querySelectorAll('[data-init="highchart"]');
    if (highchartEls.length) {
        moya.loader.js('/static/local/ext-highchart/highcharts.bundle.js').then(function () {
            highchartEls.forEach(function (el) {
                var dataEl = el.querySelector('.moya-highchart-data');
                var chartEl = el.querySelector('.moya-highchart-container');
                if (!dataEl) {
                    return;
                }
                var options = JSON.parse(dataEl.textContent);
                if (!options) {
                    return;
                }
                new Highcharts.Chart(chartEl, options);
            });
        }).catch(function (error) {
            console.error(error);
        });
    }

}());
typeof tsBuild === 'function' && tsBuild();})();
